export default __webpack_public_path__ + "static/media/Rohit.790d866b.jpg";